import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";
import { buildURL, buildURLForCategory } from "../../utils/buildURL";
import Link from "../../utils/Link";
import "./style.scss";
import BreadcrumbsWrapper from "./wrapper";
// import data from "./data";

const BreadcrumbsItems = ({ data, userLanguage }) => {
  if (!data) {
    return null;
  }

  return (
    <>
      {data && data.parentCategory !== null && (
        <BreadcrumbsItems data={data.parentCategory} />
      )}
      <Link
        to={`${buildURLForCategory(data)}`}
        className="breadcrumbs__link"
        title={text(data.title, userLanguage)}
      >
        <font>
          <font>{text(data.title, userLanguage)}</font>
        </font>
      </Link>
    </>
  );
};

const Breadcrumbs = ({ data }) => {
  const { userLanguage } = useContext(LanguageContext);

  if (!data) {
    return null;
  }

  const children = data.category ? data.category : data.parentCategory;

  return (
    <BreadcrumbsWrapper>
      <Link to="/" title="begining" className="breadcrumbs__home">
        <i className="i-home-alt"></i>
      </Link>
      <BreadcrumbsItems data={children} userLanguage={userLanguage} />
      <span
        className="breadcrumbs__link"
        title={text(data.title, userLanguage)}
      >
        <font>
          <font>{text(data.title, userLanguage)}</font>
        </font>
      </span>
    </BreadcrumbsWrapper>
  );
};

export default Breadcrumbs;
// export default function Breadcrumbs({data}) {
//   const first = data.slice(0, -1);
//   const last = data[data.length - 1];

//   return (
//     <nav className="breadcrumbs">
//       {first.map((item, index) => {
//         return (
//           <>
//             {index === 0 && (
//               <a href="/bg" title="begining" className="breadcrumbs__home">
//                 <i className="i-home-alt"></i>
//               </a>
//             )}

//             <a href={item.link} className="breadcrumbs__link" title={item.text}>
//               <font>
//                 <font>{item.text}</font>
//               </font>
//             </a>
//           </>
//         );
//       })}

//       <span className="breadcrumbs__link">
//         <font>
//           <font>{last.text}</font>
//         </font>
//       </span>
//     </nav>
//   );
// }
